
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileCheck, FilePieChart, FileWarning } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface ComplianceSummaryCardsProps {
  actionsPerformed: number;
  complianceImprovement: number;
  issuesDetected: number;
}

export const ComplianceSummaryCards = ({ 
  actionsPerformed, 
  complianceImprovement, 
  issuesDetected 
}: ComplianceSummaryCardsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={cn(
      "grid gap-4",
      isMobile ? "grid-cols-1" : "grid-cols-3"
    )}>
      <Card className="bg-muted/50 dark:bg-slate-800/50 border-0 overflow-hidden">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <div className="h-10 w-10 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-2">
            <FileCheck className="h-5 w-5 text-green-600 dark:text-green-400" />
          </div>
          <p className="text-2xl font-bold">{actionsPerformed}</p>
          <p className="text-sm text-muted-foreground">Actions Performed</p>
        </CardContent>
      </Card>
      
      <Card className="bg-muted/50 dark:bg-slate-800/50 border-0 overflow-hidden">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <div className="h-10 w-10 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mb-2">
            <FilePieChart className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="flex flex-col items-center">
            <p className="text-2xl font-bold">+{complianceImprovement}%</p>
            <p className="text-sm text-muted-foreground">Compliance Improvement</p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-muted/50 dark:bg-slate-800/50 border-0 overflow-hidden">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <div className="h-10 w-10 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mb-2">
            <FileWarning className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          </div>
          <p className="text-2xl font-bold">{issuesDetected}</p>
          <p className="text-sm text-muted-foreground">Issues Detected</p>
        </CardContent>
      </Card>
    </div>
  );
};
